export default __webpack_public_path__ + "static/media/serpro.d3d320a5.png";